import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["disabled", "bsStyle", "className"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Caret from './Caret';
var SplitCaretButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var disabled = _ref.disabled,
    bsStyle = _ref.bsStyle,
    className = _ref.className,
    remainingProps = _objectWithoutProperties(_ref, _excluded);
  var splitCaretButtonClasses = classNames('dropdown-toggle', 'btn', "btn-".concat(bsStyle), disabled && 'disabled', className);
  return /*#__PURE__*/React.createElement("button", _extends({}, remainingProps, {
    role: "button",
    type: "button",
    className: splitCaretButtonClasses,
    ref: ref
  }), /*#__PURE__*/React.createElement(Caret, null));
});
export default SplitCaretButton;
SplitCaretButton.propTypes = {
  disabled: PropTypes.bool,
  bsStyle: PropTypes.oneOf(['default', 'primary', 'info', 'warning', 'danger', 'success', 'link', 'muted']),
  className: PropTypes.string
};